import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2TwoPointOIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 64.223 30.666",
    fill: color,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 24.991l9.866-8.09c3.687-3.051 5.124-4.658 5.124-7.116a3.633 3.633 0 00-3.98-3.853c-2.288 0-3.853 1.268-6.056 3.98L.381 6.229C3.301 2.246 6.137.088 11.43.088c6.144 0 10.209 3.6 10.209 9.146v.085c0 4.954-2.543 7.412-7.794 11.48l-4.827 3.726h12.917v5.632H0zM26.951 23.38h6.859v6.777h-6.858zM37.88 15.418v-.085C37.88 6.733 43.216 0 51.094 0c7.836 0 13.129 6.653 13.129 15.248v.085c0 8.6-5.293 15.333-13.214 15.333S37.88 24.016 37.88 15.418zm19.652 0v-.085c0-5.378-2.624-9.443-6.522-9.443s-6.437 3.937-6.437 9.358v.085c0 5.42 2.585 9.446 6.522 9.446s6.437-3.98 6.437-9.361z"
    })
  });
};

export { PM2TwoPointOIcon };
//# sourceMappingURL=two-point-o.js.map
